const kayttotarkoitukset = [
  {id: 0, group: 1, label: 'Päiväkoti (päiväkäytössä) / Kokoontumistila', category: 'paivakoti'},
  {id: 1, group: 1, label: 'Koulu / Kokoontumistila', category: 'koulu'},
  {id: 2, group: 1, label: 'Ravintola / Kokoontumistila', category: 'ravintola'},
  {id: 3, group: 2, label: 'Myymälä / Liiketila', category: 'myymala'},
  {id: 4, group: 1, label: 'Kirjasto / Kokoontumistila', category: 'kirjasto'},
  {id: 5, group: 3, label: 'Pientalo / Asunto (kerrokset samaa asuntoa)', category: 'pientalo'},
  {id: 6, group: 3, label: 'Rivitalo / Asunto (kerrokset samaa asuntoa)', category: 'rivitalo'},
  {id: 7, group: 4, label: 'Asuinkerrostalo / Asunto', category: 'asuinkerrostalo'},
  {id: 8, group: 5, label: 'Toimisto / Työpaikkatila', category: 'toimisto'},
  {id: 9, group: 6, label: 'Hotelli / Majoitustila', category: 'hotelli'},
  {id: 10, group: 7, label: 'Palvelutalo / Hoitolaitos', category: 'palvelutalo'}
]

export const kayttoResolv = (id, value = 'label', defaultValue = '') => {
  for (let i = 0; i < kayttotarkoitukset.length; i++) {
    const kt = kayttotarkoitukset[i]
    if (kt.id === id) {
      return kt[value]
    }
  }
  return defaultValue
}

export default kayttotarkoitukset



// WEBPACK FOOTER //
// ./src/data/kayttotarkoitukset.js